import * as React from 'react';
import {Link} from 'react-router';
import {assets} from "../helpers";

declare const require: any;
const $: any = require('jquery');
window['$'] = $;
window['jQuery'] = $;

export class Layout extends React.Component<any, any> {
    componentWillUnmount() {
        let $nav = $('nav');
        $nav.find('a').off('click');
    }
    
    componentDidMount() {
        $('.icons').find('A').on('click', function (e) {
            e.preventDefault();
            let $rel = $(this),
                shareUrl = $rel.attr('href');
        
            shareUrl = shareUrl.replace('{title}', $('head meta[property="og:title"]'));
            shareUrl = shareUrl.replace('{text}', $('head meta[property="og:description"]'));
            if ($rel.data('tab')) {
                window.open(shareUrl);
            } else {
                window.open(shareUrl, $rel.attr('class').split(' ')[1], 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
            }
        });
    }
    
    render() {
        return (
            <div>
                <header>
                    <Link to="/">
                        <img src={assets('logo-loudhead.png')} />
                    </Link>
                    <nav>
                        <Link to="/visitors">Посетителям</Link>
                        <Link to="/members">Участникам</Link>
                        <a href="/#about">О выставке</a>
                        <a href="/#contacts">Контакты</a>
                    </nav>
                </header>
                {this.props.children}
                <footer>
                    <a name="contacts" />
                    <div className="info">
                        <aside className="contacts">
                            <h4>Оргкомитет</h4>
                            <address>
                                <strong>Литвиненко Надежда Михайловна</strong><br />
                                Тел.: +7 (495) 212-10-51 <br />
                                Тел.: 8 (916) 465-80-17 <br />
                                E-mail:&nbsp; {atob('b3JnQGxvdWRoZWFkLnJ1')}
                            </address>
                        </aside>
                        <aside className="partners">
                            <div className="row">
                                <div className="col-md-6">
                                    <a href="https://doctorhead.ru/" target="_blank"><img src={assets("drhead-logo.png")} /></a>
                                </div>
                                <div className="col-md-6">
                                    <a href="http://stereo.ru/" target="_blank"><img src={assets("stereoru-logo.png")} /></a>
                                </div>
                                <div className="col-md-6">
                                    <a href="http://personalaudio.ru/" target="_blank"><img src={assets("pa-logo.png")} /></a>
                                </div>
                            </div>
                        </aside>
                    </div>
                    
                    <div className="bottom"><b>LOUDHEAD 2014-{new Date().getFullYear()}</b>
                        <div className="icons">
                            <a href="http://twitter.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Ftw"
                                  target="_blank" className="icon icon-tw" />
                            <a href="http://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Floudhead.ru%2F%3Ffb"
                                target="_blank" className="icon icon-fb" />
                            <a href="https://plus.google.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Fgp" target="_blank"
                                className="icon icon-gp" />
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/layout/Layout.tsx
 **/